import { CommunityType } from 'types/communities';

const getAverage = (instance: CommunityType) => {
  const distanceValues = Object.values(instance.distances ?? {}).filter(
    (value) => typeof value === 'number'
  ) as number[];
  return distanceValues.length
    ? distanceValues.reduce((a: number, b: number) => a + b, 0) / distanceValues.length
    : Infinity;
};

export const sortCommunitiesByDistance = (communities: CommunityType[]) => {
  if (!Array.isArray(communities)) return [];
  return [...communities].sort((a, b) => {
    return getAverage(a) - getAverage(b);
  });
};
